export default function(state={}, action){
    switch(action.type){
        case "GET_NODE_INFO":
            return action.payload;
        default:
            return state;
    }
}